import React from 'react';
import {Alert} from "@material-ui/lab";
import Snackbar from '@material-ui/core/Snackbar';
import {IsLP_MP_SP} from "my-styles/media/media";

export const ALERT_TYPES = {
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error",
    INFO: "info"
}

export default function AlertMessage(props) {
    let message = undefined
    if (props.message) {
        message = props.message
    }
    let alertType = ALERT_TYPES.ERROR
    if (props.alertType) {
        alertType = props.alertType
    }
    return (<>
            {message &&
            <Snackbar
                autoHideDuration={5000}
                anchorOrigin={IsLP_MP_SP() ?
                    {vertical: 'bottom', horizontal: 'center'} :
                    {vertical: 'top', horizontal: 'center'}}
                open={props.showStatus}
                onClose={props.onClose}>
                <Alert
                    variant="filled"
                    onClose={props.onClose}
                    severity={alertType}>
                    {message}
                </Alert>
            </Snackbar>
            }
        </>
    )
}